import { PLANBOOK_API_HOSTNAME } from 'common/utils/variables'
import { axios, reqInterceptor, reqErr, repInterceptor, repErr } from './axios'

const options = {
  baseURL: PLANBOOK_API_HOSTNAME,
  withCredentials: true,
  timeout: 10000, // 请求超时时间
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  }
}
const service = axios.create(options)
service.interceptors.request.use(reqInterceptor, reqErr)
service.interceptors.response.use(repInterceptor, repErr)

export default service